import {IInsideOrbitMenuServices} from "../../../../services/inside-orbit-menu-services/inside-orbit-menu.service.interface";
import {IInsideOrbitMenuActionInterface} from "../interface/inside-orbit-menu-action.interface";
import {HIDE_THIS_MENU} from "../../inside-orbit-menu-consts/inside-orbit-menu-text.consts";
import {HIDE_MENU_KEY} from "../../inside-orbit-menu-consts/inside-orbit-menu-services.consts";

export class HideThisMenuAction implements IInsideOrbitMenuActionInterface {
    constructor(private services: IInsideOrbitMenuServices) {}

    get text() {
        return HIDE_THIS_MENU;
    }

    execute = () =>  {
        this.services.location.redirect(HIDE_MENU_KEY);
    }
}